<template>
    <div style="height: 100%;width: 100%;overflow: auto;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form label-width="80px" class="orderFrom" style="margin-bottom: 60px;" :model="addOrderInfo" :rules="rules">
            <el-form-item label="会员卡号">
                {{addOrderInfo.cardnumber}}
            </el-form-item>
            <el-form-item label="姓名">
                {{addOrderInfo.membername}}
            </el-form-item>
            <el-form-item label="老客">
                <el-checkbox v-model="addOrderInfo.checked">老客</el-checkbox>
            </el-form-item>
            <el-form-item label="大类" prop="projecttype">
                <el-checkbox-group v-model="addOrderInfo.projecttype">
                    <el-checkbox :label="item.value" v-for="(item,index) in projectTypes" :key="index">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="门店员工" prop="staffs">
                <el-checkbox-group v-model="addOrderInfo.staffs">
                    <el-checkbox :label="item.staffid" v-for="(item,index) in staffs" :key="index">{{item.staffname}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="预约日期" prop="accountdate">
                <el-date-picker v-model="addOrderInfo.accountdate" :editable="false" value-format="yyyy-MM-dd" size="mini" style="width: 150px;" :picker-options="datePicker" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="房间" prop="roomid">
                <el-select v-model="addOrderInfo.roomid" size="mini" style="width: 150px;" placeholder="请选择" @change="roomChange">
                    <el-option v-for="item in rooms"  :key="item.roomid" :label="item.roomname" :value="item.roomid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="fromtime">
                <el-time-select size="mini" style="width: 150px;" :editable="false"
                                    placeholder="起始时间"
                                    v-model="addOrderInfo.fromtime"
                                    :picker-options="{
                                    start: '10:00',
                                    step: '00:30',
                                    end: '21:00'
                                    }">
                </el-time-select>
            </el-form-item>
            <el-form-item label="结束时间" prop="totime">
                <el-time-select size="mini" style="width: 150px;" :editable="false"
                                    placeholder="结束时间"
                                    v-model="addOrderInfo.totime"
                                    :picker-options="{
                                    start: '10:00',
                                    step: '00:30',
                                    end: '21:00',
                                    minTime: addOrderInfo.fromtime
                                    }">
                </el-time-select>
            </el-form-item>
            <el-form-item label="疗程信息" prop="courses">
                <el-checkbox-group v-model="addOrderInfo.courses">
                    <el-checkbox :label="item.courseid" v-for="(item,index) in cardCourses" :key="index">{{item.projectname}}({{item.restnumber}}次)<span style="color: red;" v-if="item.remarks!=null && item.remarks!=''">{{item.remarks}}</span></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="消耗目标" prop="xhtarget">
                <el-input type="textarea" v-model="addOrderInfo.xhtarget" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
            </el-form-item>
        </el-form>
        <van-tabbar>
            <van-button type="primary" color="#1989fa" size="large" @click="saveOrderInfo">保存</van-button>
        </van-tabbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                datePicker:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;//8.64e7=1000*60*60*24一天
                    }
                },
                sex:0,
                storeid:localStorage.getItem("storeid"),
                cardid:"",
                memberid:"",
                membername:"",
                cardnumber:"",
                memberphone:"",
                cardtypeid:"",
                orderInfo:{
                    storeid:"",
                    sysbillid:"",
                    roomid:"",
                    roomname:"",
                    projecttype:[],
                    staffs:[],
                    checked:false,
                    accountdate:"",
                    times:"",
                    cardid:"",
                    cardnumber:"",
                    membername:"",
                    memberphone:"",
                    memberid:"",
                    status:0,
                    cardtypeid:"",
                    sex:"",
                    cashsysbillid:"",
                    nextaccountdate:"",
                    fromtime:"",
                    totime:"",
                    courses:[],
                    xhtarget:"",
                },
                addOrderInfo:{

                },
                staffs:[],
                projectTypes:[],
                cardCourses:[],
                rooms:[],
                rules: {
                    projecttype: [
                        {required: true, message: "请选择项目类型", trigger: 'change'}
                    ],
                    staffs: [
                        {required: true, message: "请选择员工", trigger: 'change'}
                    ],
                    accountdate: [
                        {required: true, message: "请选择日期", trigger: 'change'}
                    ],
                    roomid: [
                        {required: true, message: "请选择房间", trigger: 'change'}
                    ],
                    fromtime: [
                        {required: true, message: "请选择开始时间", trigger: 'change'}
                    ],
                    totime: [
                        {required: true, message: "请选择结束时间", trigger: 'change'}
                    ],
                    xhtarget: [
                        {required: true, message: "请输入消耗目标", trigger: 'change'}
                    ],
                }
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.cardnumber=this.$route.query.cardnumber;
            this.memberid=this.$route.query.memberid;
            this.membername=this.$route.query.membername;
            this.sex=this.$route.query.sex;
            this.memberphone=this.$route.query.memberphone;
            this.cardtypeid=this.$route.query.cardtypeid;
            this.addOrderInfo=this.$copy(this.orderInfo);
            this.addOrderInfo.cardid=this.cardid;
            this.addOrderInfo.cardnumber=this.cardnumber;
            this.addOrderInfo.memberid=this.memberid;
            this.addOrderInfo.memberphone=this.memberphone;
            this.addOrderInfo.membername=this.membername;
            this.addOrderInfo.sex=this.sex;
            this.addOrderInfo.cardtypeid=this.cardtypeid;
            this.getCardInfoVoByCardId();
            this.getBeautyProjectTotalType();
            this.getStaffByDeptId();
            this.getCardCourseByCardId();
            this.getRoomByStore();
        },
        methods: {
            getCardInfoVoByCardId(){
                this.$post("cardinfo/getCardInfoVoByCardId",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.addOrderInfo.cardnumber=res.object.cardnumber;
                        this.addOrderInfo.memberid=res.object.memberid;
                        this.addOrderInfo.memberphone=res.object.memberphone;
                        this.addOrderInfo.membername=res.object.membername;
                        this.addOrderInfo.sex=res.object.sex;
                        this.addOrderInfo.cardtypeid=res.object.cardtypeid;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            roomChange(room){
                this.addOrderInfo.roomname=this.rooms.find((item)=>{
                    return item.roomid==room;
                }).roomname;
            },
            saveOrderInfo(){
                if(!this.addOrderInfo.memberphone){
                    this.$message({
                        message: "请输入客户信息",
                        type: 'error'
                    });
                    return;
                }

                if(!this.addOrderInfo.xhtarget){
                    this.$message({
                        message: "请输入消耗目标",
                        type: 'error'
                    });
                    return;
                }

                if(!this.addOrderInfo.sex){
                    this.$message({
                        message: "顾客资料没有选择性别，请联系管理员",
                        type: 'error'
                    });
                    return;
                }
                if(this.addOrderInfo.projecttype.length<1 && this.addOrderInfo.courses<1){
                    this.$message({
                        message: "请选择顾客需要预约的项目",
                        type: 'error'
                    });
                    return;
                }
                if(this.addOrderInfo.staffs.length<1){
                    this.$message({
                        message: "请选择预约员工",
                        type: 'error'
                    });
                    return;
                }
                if(!this.addOrderInfo.fromtime){
                    this.$message({
                        message: "请选择预约开始时间",
                        type: 'error'
                    });
                    return;
                }
                if(!this.addOrderInfo.totime){
                    this.$message({
                        message: "请选择预约结束时间",
                        type: 'error'
                    });
                    return;
                }
                if(!this.addOrderInfo.accountdate){
                    this.$message({
                        message: "请选择预约日期",
                        type: 'error'
                    });
                    return;
                }

                let order=new Object();
                order.storeid=this.storeid;
                order.roomid=this.addOrderInfo.roomid;
                order.roomname=this.addOrderInfo.roomname;
                order.accountdate=this.addOrderInfo.accountdate;
                order.fromtime=this.addOrderInfo.fromtime;
                order.totime=this.addOrderInfo.totime;
                order.cardid=this.addOrderInfo.cardid;
                order.cardnumber=this.addOrderInfo.cardnumber;
                order.membername=this.addOrderInfo.membername;
                order.memberid=this.addOrderInfo.memberid;
                order.memberphone=this.addOrderInfo.memberphone;
                order.cardtypeid=this.addOrderInfo.cardtypeid;
                order.status=1;
                order.createtor=localStorage.getItem("staffid");
                order.createtorname=localStorage.getItem("staffname");
                order.sex=this.addOrderInfo.sex;
                order.xhtarget=this.addOrderInfo.xhtarget;
                let orderDetals=[];
                let projectTypeMap=[];
                for(let val of this.projectTypes){
                    projectTypeMap[val.value]=val;
                }
                if(this.addOrderInfo.projecttype!=null && this.addOrderInfo.projecttype.length>0){
                    for(let val of this.addOrderInfo.projecttype){
                        let type=projectTypeMap[val];
                        let orderDetal = new Object();
                        orderDetal.storeid = this.storeid;
                        orderDetal.projectid = val;
                        orderDetal.projectname = type.name;
                        orderDetal.type = 1;
                        orderDetal.price = 0;
                        if(this.addOrderInfo.checked){
                            orderDetal.svrtype=1;
                        }
                        else{
                            orderDetal.svrtype=2;
                        }
                        orderDetal.number = 1;
                        orderDetal.courseid = "";
                        orderDetals.push(orderDetal);
                    }
                }

                let courseMap=[];

                if(this.addOrderInfo.courses!=null && this.addOrderInfo.courses.length>0){
                    for(let val of this.cardCourses){
                        courseMap[val.courseid]=val;
                    }

                    for(let c of this.addOrderInfo.courses){
                        let val=courseMap[c];
                        let orderDetal = new Object();
                        orderDetal.storeid = this.storeid;
                        orderDetal.projectid = val.projectid;
                        orderDetal.projectname = val.projectname;
                        if (val.type != 2) {
                            orderDetal.type = 2;
                            orderDetal.price = parseInt(val.restamount / val.restnumber);
                        } else if (val.type == 2) {
                            orderDetal.type = 3;
                            orderDetal.price = val.oneprice;
                        }
                        if(this.addOrderInfo.checked){
                            orderDetal.svrtype=1;
                        }
                        else{
                            orderDetal.svrtype=2;
                        }
                        orderDetal.coursepayid1=val.payid1;
                        orderDetal.coursepayid2=val.payid2;
                        orderDetal.coursepayid3=val.payid3;
                        orderDetal.coursepayamount1=val.payamount1;
                        orderDetal.coursepayamount2=val.payamount2;
                        orderDetal.coursepayamount3=val.payamount3;
                        orderDetal.hairlv=val.hairlv;
                        orderDetal.coursebuydate=val.buydate;
                        orderDetal.coursepayid3=val.payid3;
                        orderDetal.number = 1;
                        orderDetal.courseid = val.courseid;
                        orderDetal.yearcount=val.defaultnumber;
                        orderDetal.yearcourseid=val.yearcourseid;
                        orderDetal.restnumber=val.restnumber;
                        orderDetal.restamount=val.restamount;
                        orderDetal.projectbigtype=val.projectbigtype;
                        orderDetals.push(orderDetal);
                    }
                }
                let staffMap=[];
                for(let val of this.staffs){
                    staffMap[val.staffid]=val;
                }
                let orderStaffs=[];
                if(this.addOrderInfo.staffs.length>0){
                    for(let val of this.addOrderInfo.staffs){
                        let orderStaff = new Object();
                        orderStaff.storeid = this.storeid;
                        orderStaff.staffid = val;
                        let staff=staffMap[val];
                        orderStaff.staffname = staff.staffname;
                        orderStaffs.push(orderStaff);
                    }
                }

                let saveOrderInfo=new Object();
                saveOrderInfo.orderInfo=order;
                saveOrderInfo.orderDetals=orderDetals;
                saveOrderInfo.orderStaffs=orderStaffs;
                this.$postw("order/saveOrder",saveOrderInfo).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.historyBack();
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getRoomByStore(){
                this.$post("store/getRoomByStore",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.rooms=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getCardCourseByCardId(){
                this.$post("cardinfo/getCardCourseByCardId",{cardid:this.cardid,showRest:0}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                if(val.projectbigtype==2){
                                    this.cardCourses.push(val);
                                }
                            }
                        }
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getBeautyProjectTotalType(){
                this.$post("project/getBeautyProjectTotalType",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.projectTypes=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getStaffByDeptId(){
                this.$post("staff/getStaffByDeptId",{storeid:this.storeid,deptid:"32"}).then(res=>{
                    if(res.sucess){
                        this.staffs=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .orderFrom .el-form-item{
        margin-bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/beauty/addorder.vue